__turbopack_context__.v({
  "className": "inter_21b689d4-module__VP-eEG__className",
});
